import React, { ReactElement, FunctionComponent, useState, useCallback } from 'react'
import WebSwitch from 'react-switch'
import { SwitchProps } from './SwitchProps'

const Switch: FunctionComponent<SwitchProps> = ({
    initialValue = false,
    onColor,
    offColor,
    toggleSwitch,
    testID,
}): ReactElement => {
    const [switchValue, onChange] = useState(initialValue)
    const onChangeValue = useCallback(
        (value: boolean): void => {
            onChange(value)
            toggleSwitch(value)
        },
        [toggleSwitch]
    )
    return (
        <WebSwitch
            onChange={onChangeValue}
            checked={switchValue}
            onColor={onColor}
            offColor={offColor}
            checkedIcon={false}
            uncheckedIcon={false}
            data-testid={testID}
        />
    )
}

export default Switch
